
import { makeObservable, observable } from "mobx";
import { WeekDay } from "@common/models/Enums";

export interface IHospitalHoursModel {
    hospitalHoursId: number;
    dayOfWeek: WeekDay.Day;
    openTime: string;
    closeTime: string;
    isOpen: boolean;
}

export class HospitalHoursModel implements IHospitalHoursModel {
    @observable hospitalHoursId: number;
    @observable dayOfWeek: WeekDay.Day;
    @observable openTime: string;
    @observable closeTime: string;
    @observable isOpen: boolean;

    constructor(hospitalHoursModel: IHospitalHoursModel) {
        this.hospitalHoursId = hospitalHoursModel.hospitalHoursId;
        this.dayOfWeek = hospitalHoursModel.dayOfWeek;
        this.openTime = hospitalHoursModel.openTime;
        this.closeTime = hospitalHoursModel.closeTime;
        this.isOpen = hospitalHoursModel.isOpen;

        makeObservable(this, undefined, { autoBind: true });
    }
}
